export default __webpack_public_path__ + "static/media/banking.f3ad2a12.png";